export const NAME_EMPTY = "Name cannot be empty";
export const EMAIL_EMPTY = "Email cannot be empty";
export const EMAIL_INVALID = "Email should be valid";
export const PASSWORD_EMPTY = "Password cannot be empty";
export const PASSWORD_MIN = "Password cannot be less than 6 symbols";
export const PASSWORD_MATCH = "The passwords do not match";
